import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.machinedetails.components';

export default defineMessages({
    stopReasonCode: {
        id: `${scope}.machinestopeditdialog.label.stopreasoncode`,
        defaultMessage: 'Stop Reason Code',
    },
    comment: {
        id: `${scope}.machinestopeditdialog.label.comment`,
        defaultMessage: 'Comment',
    },
    machineName: {
        id: `${scope}.machinestopeditdialog.label.machinename`,
        defaultMessage: 'Machine Name',
    },
    duration: {
        id: `${scope}.machinestopeditdialog.label.duration`,
        defaultMessage: 'Duration',
    },
    minutes: {
        id: `${scope}.machinestopeditdialog.label.minutes`,
        defaultMessage: 'minutes',
    },
    item: {
        id: `${scope}.machinestopeditdialog.label.item`,
        defaultMessage: 'Item',
    },
    updated: {
        id: `${scope}.machinestopeditdialog.label.updated`,
        defaultMessage: 'Updated',
    },
    updatedBy: {
        id: `${scope}.machinestopeditdialog.label.updatedBy`,
        defaultMessage: 'Updated by',
    },
    machineStatus: {
        id: `${scope}.label.machineStatus`,
        defaultMessage: 'Machine status',
    },
    machine: {
        id: `${scope}.label.machine`,
        defaultMessage: 'Machine',
    },
    itemInProduction: {
        id: `${scope}.label.itemInProduction`,
        defaultMessage: 'Item in production',
    },
    productionOrder: {
        id: `${scope}.label.productionOrder`,
        defaultMessage: 'Production order',
    },
    percentageDone: {
        id: `${scope}.label.percentageDone`,
        defaultMessage: 'Percentage done',
    },
    t: {
        id: `${scope}.label.t`,
        defaultMessage: 'A',
    },
    a: {
        id: `${scope}.label.a`,
        defaultMessage: 'P',
    },
    k: {
        id: `${scope}.label.k`,
        defaultMessage: 'Q',
    },
    tak: {
        id: `${scope}.label.tak`,
        defaultMessage: 'OEE',
    },
    takt: {
        id: `${scope}.label.takt`,
        defaultMessage: 'Pace',
    },
    plannedQty: {
        id: `${scope}.label.plannedQty`,
        defaultMessage: 'Planned Qty',
    },
    reportedQty: {
        id: `${scope}.label.reportedQty`,
        defaultMessage: 'Reported Qty',
    },
    remainingQty: {
        id: `${scope}.label.remainingQty`,
        defaultMessage: 'Remaining Qty',
    },
    remainingTime: {
        id: `${scope}.label.remainingTime`,
        defaultMessage: 'Remaining time',
    },
    remainingTimeDays: {
        id: `${scope}.label.remainingTimeDays`,
        defaultMessage: 'Remaining time',
    },
    scrappedQty: {
        id: `${scope}.label.scrappedQty`,
        defaultMessage: 'Scrapped Qty',
    },
    nrOfCycles: {
        id: `${scope}.label.nrOfCycles`,
        defaultMessage: 'Nr of cycles',
    },
    days: {
        id: `${scope}.label.days`,
        defaultMessage: 'days',
    },
    downtime: {
        id: `${scope}.label.downtime`,
        defaultMessage: 'Downtime',
    },
    downtimeNoOee: {
        id: `${scope}.label.downtimeNoOee`,
        defaultMessage: 'Downtime not affecting OEE',
    },
    uptime: {
        id: `${scope}.label.uptime`,
        defaultMessage: 'Uptime',
    },
    uptimeExplenation: {
        id: `${scope}.label.uptimeExplenation`,
        defaultMessage: "Uptime\nThe time when the machine is actually running and producing parts according to plan.\n\nExamples:\n• Machine is running and producing parts\n• Automatic production mode\n• Stable production without stops",
    },
    downtimeExplenation: {
        id: `${scope}.label.downtimeExplenation`,
        defaultMessage: "Downtime that affects OEE\nStops or losses that count as production loss and reduce the OEE value.\n\nExamples:\n• Unplanned stops\n• Machine breakdowns\n• Tool changes taking longer than planned\n• Material shortage during planned production time\n• Setup and adjustment problems\n\nIn short: things that reduce production when the machine should be running.",
    },
    downtimeNoOeeExplenation: {
        id: `${scope}.label.downtimeNoOeeExplenation`,
        defaultMessage: "Downtime that does NOT affect OEE\nPlanned or expected stops that are excluded from OEE and do not count as losses.\n\nExamples:\n• Planned maintenance\n• Breaks and pauses\n• Scheduled meetings\n• Planned changeovers\n• Machine stopped outside planned production time\n\nIn short: stops that are “okay” because they are already part of the plan.",
    },
    info: {
        id: `${scope}.label.info`,
        defaultMessage: 'Info',
    },
    description: {
        id: `${scope}.label.description`,
        defaultMessage: 'Description',
    },
    opcServerUrl: {
        id: `${scope}.label.opcServerUrl`,
        defaultMessage: 'OPC Server Url',
    },
    opcServerStatus: {
        id: `${scope}.label.opcServerStatus`,
        defaultMessage: 'OPC Server Status',
    },
    area: {
        id: `${scope}.label.area`,
        defaultMessage: 'Area',
    },
    machineType: {
        id: `${scope}.label.machineType`,
        defaultMessage: 'Machine type',
    },
    oeePercentWarning: {
        id: `${scope}.label.oeePercentWarning`,
        defaultMessage: 'OEE Percent Warning',
    },
    oeePercentBad: {
        id: `${scope}.label.oeePercentBad`,
        defaultMessage: 'OEE Percent Bad',
    },
    avalibleStopReasonCodes: {
        id: `${scope}.label.avalibleStopReasonCodes`,
        defaultMessage: 'Available stop reason codes',
    },
    idealCycleTimeActive: {
        id: `${scope}.label.idealCycleTimeActive`,
        defaultMessage: 'Ideal CT',
    },
    lastCycleTime: {
        id: `${scope}.label.lastCycleTime`,
        defaultMessage: 'Last CT',
    },
    save: {
        id: `${scope}.label.save`,
        defaultMessage: 'Save',
    },
    splitStop: {
        id: `${scope}.label.splitStop`,
        defaultMessage: 'Split stop',
    },
    editStop: {
        id: `${scope}.label.editStop`,
        defaultMessage: 'Edit stop',
    },
    editSettings: {
        id: `${scope}.label.editSettings`,
        defaultMessage: 'Edit settings',
    },
    editComment: {
        id: `${scope}.label.editComment`,
        defaultMessage: 'Add/Edit comment',
    },
    stopCount: {
        id: `${scope}.label.stopCount`,
        defaultMessage: 'Stop count',
    },
    currentShiftFilter: {
        id: `${scope}.label.filters.currentShift`,
        defaultMessage: 'Current shift',
    },
    prevShiftFilter: {
        id: `${scope}.label.filters.prevShift`,
        defaultMessage: 'Prev.shift',
    },
    dayFilter: {
        id: `${scope}.label.filters.24h`,
        defaultMessage: '24h',
    },
    threeDayFilter: {
        id: `${scope}.label.filters.72h`,
        defaultMessage: '72h',
    },
    manualFilter: {
        id: `${scope}.label.filters.manual`,
        defaultMessage: 'Manual',
    },
    weekFilter: {
        id: `${scope}.label.filters.week`,
        defaultMessage: 'Week',
    },
    linksAndFunctions: {
        id: `${scope}.label.linksAndFunctions`,
        defaultMessage: 'Manual',
    },
    machineComments: {
        id: `${scope}.label.machineComments`,
        defaultMessage: 'Manual',
    },
    settingsButtonTooltip: {
        id: `${scope}.label.settingsButtonTooltip`,
        defaultMessage: 'Manual',
    },
    commentButtonTooltip: {
        id: `${scope}.label.commentButtonTooltip`,
        defaultMessage: 'Manual',
    },
    grafanaButtonTooltip: {
        id: `${scope}.label.grafanaButtonTooltip`,
        defaultMessage: 'Manual',
    },
    plcLogButtonTooltip: {
        id: `${scope}.label.plcLogButtonTooltip`,
        defaultMessage: 'Manual',
    },
    oeeStartDateTime: {
        id: `${scope}.label.oeeStartDateTime`,
        defaultMessage: 'OEE Start DateTime',
    },
    fromDate: {
        id: `${scope}.label.fromDate`,
        defaultMessage: 'From date',
    },
    fromTime: {
        id: `${scope}.label.fromTime`,
        defaultMessage: 'To date',
    },
    toDate: {
        id: `${scope}.label.toDate`,
        defaultMessage: 'From time',
    },
    toTime: {
        id: `${scope}.label.toTime`,
        defaultMessage: 'To time',
    },
    activityTriggered: {
        id: `${scope}.label.activityTriggered`,
        defaultMessage: 'An activity was created when the stop was updated.',
    },
    useStopPageOnGrafanaLink: {
        id: `${scope}.label.useStopPageOnGrafanaLink`,
        defaultMessage: 'Use stop page on Grafana link',
    },
    showPaceAsCycleTime: {
        id: `${scope}.label.showPaceAsCycleTime`,
        defaultMessage: 'Show pace as cycle time',
    },
    meassureAvailability: {
        id: `${scope}.label.meassureAvailability`,
        defaultMessage: 'Measure availability',
    },
    availabilityPercentWarning: {
        id: `${scope}.label.availabilityPercentWarning`,
        defaultMessage: 'Availability percent warning',
    },
    availabilityPercentBad: {
        id: `${scope}.label.availabilityPercentBad`,
        defaultMessage: 'Availability percent bad',
    },
    meassurePerformance: {
        id: `${scope}.label.meassurePerformance`,
        defaultMessage: 'Measure performance',
    },
    notifyOnNewActivity: {
        id: `${scope}.label.notifyOnNewActivity`,
        defaultMessage: 'Notify on new activity',
    },
    notifyEmail: {
        id: `${scope}.label.notifyEmail`,
        defaultMessage: 'Notify email',
    },
    performancePercentWarning: {
        id: `${scope}.label.performancePercentWarning`,
        defaultMessage: 'Performance percent warning',
    },
    performancePercentBad: {
        id: `${scope}.label.performancePercentBad`,
        defaultMessage: 'Performance percent bad',
    },
    meassureQuality: {
        id: `${scope}.label.meassureQuality`,
        defaultMessage: 'Measure quality',
    },
    qualityPercentWarning: {
        id: `${scope}.label.qualityPercentWarning`,
        defaultMessage: 'Quality percent warning',
    },
    qualityPercentBad: {
        id: `${scope}.label.qualityPercentBad`,
        defaultMessage: 'Quality percent bad',
    },
    targetValue: {
        id: `${scope}.label.targetValue`,
        defaultMessage: 'Target value',
    },
    newActivity: {
        id: `${scope}.label.newActivity`,
        defaultMessage: 'New activity',
    },
    newActivityText: {
        id: `${scope}.label.newActivityText`,
        defaultMessage: 'There is a new activity for this machine. Check the activity tab for more information.',
    },
    Ok: {
        id: `${scope}.label.ok`,
        defaultMessage: 'Ok',
    },
    showActivities: {
        id: `${scope}.label.showActivities`,
        defaultMessage: 'Show activities',
    },
    activity: {
        id: `${scope}.label.activity`,
        defaultMessage: 'Activity',
    },
    completeBefore: {
        id: `${scope}.label.completeBefore`,
        defaultMessage: 'Complete before',
    },
    in: {
        id: `${scope}.label.in`,
        defaultMessage: 'in',
    },
    hours: {
        id: `${scope}.label.hours`,
        defaultMessage: 'hours',
    },
    autocode: {
        id: `${scope}.label.autocode`,
        defaultMessage: 'Autocode stops',
    },
    machineActivitiesTimespanHelptext: {
        id: `${scope}.label.machineActivitiesTimespanHelptext`,
        defaultMessage: 'Help text',
    },
    pace: {
        id: `${scope}.label.pace`,
        defaultMessage: 'Pace',
    },
    idealPace: {
        id: `${scope}.label.idealPace`,
        defaultMessage: 'Ideal pace',
    },
    currentPace: {
        id: `${scope}.label.currentPace`,
        defaultMessage: 'Current pace',
    },
    avgPaceForPo: {
        id: `${scope}.label.avgPaceForPo`,
        defaultMessage: 'Avgerage pace for PO',
    },
    timespanSelectorLabel: {
        id: `${scope}.label.timespanSelectorLabel`,
        defaultMessage: 'Show the pace for the last:',
    },
    avgCycleTimeForPo: {
        id: `${scope}.label.avgCycleTimeForPo`,
        defaultMessage: 'Avgerage cycle time for PO',
    },
    useCycleTimeForPace: {
        id: `${scope}.label.useCycleTimeForPace`,
        defaultMessage: 'Show pace as with unit',
    },
    currentCycleTime: {
        id: `${scope}.label.currentCycleTime`,
        defaultMessage: 'Current cycle time',
    },
    cycleTime: {
        id: `${scope}.label.cycleTime`,
        defaultMessage: 'Cycle time',
    },
    time: {
        id: `${scope}.label.time`,
        defaultMessage: 'Time',
    },
    autocodeInstructions: {
        id: `${scope}.label.autocodeInstructions`,
        defaultMessage: 'Autocode instructions',
    },
    cancelAutocode: {
        id: `${scope}.label.cancelAutocode`,
        defaultMessage: 'Cancel autocode',
    },
    autocodeInProgress: {
        id: `${scope}.label.autocodeInProgress`,
        defaultMessage: 'Autocode in progress',
    },
    autocodeEndsIn: {
        id: `${scope}.label.autocodeEndsIn`,
        defaultMessage: 'Autocode ends in: ',
    },
    endAutocodeNow: {
        id: `${scope}.label.endAutocodeNow`,
        defaultMessage: 'End now',
    },
    unitsPerHour: {
        id: `${scope}.label.unitsPerHour`,
        defaultMessage: 'Units per hour',
    },
    changeMachineTabOnInactivity: {
        id: `${scope}.label.changeMachineTabOnInactivity`,
        defaultMessage: 'Change machine tab on inactivity',
    },
    inactivityTime: {
        id: `${scope}.label.inactivityTime`,
        defaultMessage: 'Inactivity time',
    },
    changeToTabIfRunning: {
        id: `${scope}.label.changeToTabIfRunning`,
        defaultMessage: 'Change to tab if running',
    },
    changeToTabIfStopped: {
        id: `${scope}.label.changeToTabIfStopped`,
        defaultMessage: 'Change to tab if not running',
    },
    alarm: {
        id: `${scope}.label.alarm`,
        defaultMessage: 'Alarm.',
    },
    high: {
        id: `${scope}.label.high`,
        defaultMessage: 'High.',
    },
    low: {
        id: `${scope}.label.low`,
        defaultMessage: 'Low.',
    },
    pausedalarm: {
        id: `${scope}.label.pausedalarm`,
        defaultMessage: 'Paused alarm.',
    },
    moduleNotEnabled: {
        id: `${scope}.moduleNotEnabled`,
        defaultMessage: 'Module not enabled',
    },
    speedUnitType: {
        id: `${scope}.label.speedUnitType`,
        defaultMessage: 'Speed unit type',
    },
    speedUnitTypeNotSet: {
        id: `${scope}.label.speedUnitTypeNotSet`,
        defaultMessage: 'Not set',
    },
    speedUnitTypeCycleTimeSeconds: {
        id: `${scope}.label.speedUnitTypeCycleTimeSeconds`,
        defaultMessage: 'Cycle time (s)',
    },
    speedUnitTypePaceItemsPerHour: {
        id: `${scope}.label.speedUnitTypePaceItemsPerHour`,
        defaultMessage: 'Pace (items/hour)',
    },
    speedUnitTypeSpeedMetersPerMinute: {
        id: `${scope}.label.speedUnitTypeSpeedMetersPerMinute`,
        defaultMessage: 'Speed (m/min)',
    },
    speedUnitTypeSpeedKgPerMinute: {
        id: `${scope}.label.speedUnitTypeSpeedKgPerMinute`,
        defaultMessage: 'Speed (kg/min)',
    },
    tabDashboard: {
        id: `${scope}.label.tabDashboard`,
        defaultMessage: 'Dashboard',
    },
    tabActivities: {
        id: `${scope}.label.tabActivities`,
        defaultMessage: 'Activities',
    },
    tabTakt: {
        id: `${scope}.label.tabTakt`,
        defaultMessage: 'Takt',
    },
    tabSensorData: {
        id: `${scope}.label.tabSensorData`,
        defaultMessage: 'Sensor data',
    },
    tabAlarms: {
        id: `${scope}.label.tabAlarms`,
        defaultMessage: 'Alarms',
    },
    tabMachineStops: {
        id: `${scope}.label.tabMachineStops`,
        defaultMessage: 'Machine stops',
    },
    downtimeInMinutes: {
        id: `${scope}.label.downtimeInMinutes`,
        defaultMessage: 'Downtime in minutes',
    },
    noActiveProductionOrder: {
        id: `${scope}.label.noActiveProductionOrder`,
        defaultMessage: 'No active production order',
    },
    noSensorData: {
        id: `${scope}.label.noSensorData`,
        defaultMessage: 'No sensor data',
    },
    splitStopsOnShiftChange: {
        id: `${scope}.label.splitStopsOnShiftChange`,
        defaultMessage: 'Split stop on shift change',
    },
    quickSelectMachine: {
        id: `${scope}.label.quickSelectMachine`,
        defaultMessage: 'Quick select machine',
    },
    changingToActiveShift: {
        id: `${scope}.label.changingToActiveShift`,
        defaultMessage: 'Changing to "active shift" due to shift change.',
    },
    resetTimespanOnShiftChange: {
        id: `${scope}.label.resetTimespanOnShiftChange`,
        defaultMessage: 'Reset timespan on shift change',
    },
    overrideUndefinedStopReasonCodeId: {
        id: `${scope}.label.overrideUndefinedStopReasonCodeId`,
        defaultMessage: 'Override undefined stop reason code',
    },
    loadErrorTitle: {
        id: `${scope}.label.loadErrorTitle`,
        defaultMessage: "We can't load machine data at the moment. We are trying to reconnect.",
    },
    loadErrorBody: {
        id: `${scope}.label.loadErrorBody`,
        defaultMessage: 'If the problem persists, try reloading the page or logging out and back in.',
    },
    retry: {
        id: `${scope}.label.retry`,
        defaultMessage: 'Retry',
    },
    backToList: {
        id: `${scope}.label.backToMachines`,
        defaultMessage: 'Back to machines',
    },
    lastAttemptTime: {
        id: `${scope}.label.lastAttemptTime`,
        defaultMessage: 'Last attempt time',
    },
    initialErrorTime: {
        id: `${scope}.label.initialErrorTime`,
        defaultMessage: 'Initial error time',
    },
    otherStopReasonCodes: {
        id: `${scope}.label.otherStopReasonCodes`,
        defaultMessage: 'Other stop reason codes',
    },
    quickPicks: {
        id: `${scope}.label.quickPicks`,
        defaultMessage: 'Quick picks - Most used stop reason codes on the machine last 24h',
    },
    searchStopReasonCodes: {
        id: `${scope}.label.searchStopReasonCodes`,
        defaultMessage: 'Search stop reason codes...',
    },
    stopDetectionThreshold: {
        id: `${scope}.label.stopDetectionThreshold`,
        defaultMessage: 'The number of seconds since the last activity before the machine is detected as a stop.',
    },
    uncodedStopsAndOpenActivities: {
        id: `${scope}.label.uncodedStopsAndOpenActivities`,
        defaultMessage: 'Uncoded stops and open activities'
    },
    machineInSetup: {
        id: `${scope}.label.machineInSetup`,
        defaultMessage: 'Machine in setup',
    },
    machineInSetupEndsIn: {
        id: `${scope}.label.machineInSetupEndsIn`,
        defaultMessage: 'Machine in setup ends in: ',
    },
    machineInSetupLate: {
        id: `${scope}.label.machineInSetupLate`,
        defaultMessage: 'Machine in setup is late by: ',
    },
    machineInSetupOverlayTitle: {
        id: `${scope}.label.machineInSetupOverlayTitle`,
        defaultMessage: "Machine in setup",
    },
    machineInSetupOverlayDescription: {
        id: `${scope}.label.machineInSetupOverlayDescription`,
        defaultMessage: "The machine is currently in setup. Other information on the page is dimmed until the setup is expected to be finished. You can temporarily close this box to work with other information in the OEE system, but the setup is both started and finished in the ERP system. If this box is closed before the setup is finished, it will be displayed again when the page is reloaded or if you click on the setup info banner on the machine page.",
    },
    close: {
        id: `${scope}.label.close`,
        defaultMessage: "Close",
    },

    startLabel: {
        id: `${scope}.label.start`,
        defaultMessage: 'Start',
    },
    reportLabel: {
        id: `${scope}.label.report`,
        defaultMessage: 'Report',
    },
    stopLabel: {
        id: `${scope}.label.stop`,
        defaultMessage: 'Stop',
    },
    dialogheadding: {
        id: `${scope}.label.dialogheadding`,
        defaultMessage: 'Active production order details for machine ',
    },
    thisWeek: {
        id: `${scope}.label.thisWeek`,
        defaultMessage: "This week",
    },
    lastWeek: {
        id: `${scope}.label.lastWeek`,
        defaultMessage: "Last week",
    },
});